<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-row :gutter="24" v-if="DestekBilgi">
      <el-col :span="24">
        <h5 class="Baslik">{{ DestekBilgi.Baslik }}</h5>
      </el-col>
      <el-col :span="18">
        <div class="Yorumlar">
          <div class="Yorum" :class="y.Ai>0?'ai':''" v-for="y in Yorumlar">
            <div class="Icerik" v-html="y.Icerik"></div>
            <p class="Tarih">{{ y.tarih }}</p>
            <p v-if="y.Ai==0" class="Kisi">{{ y.Kullanici }} <small>{{ y.kMail }}</small></p>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="d-block bg-primary text-white" style="padding:10px;border-radius: 3px">
          <small class="d-block">Durum</small>
          {{ DestekBilgi.DurumText }}
        </div>
        <div v-if="Data.Durum!='3'">
          <hr>
          <el-input type="textarea" v-model="Cevap" :rows="5" placeholder="Cevap metnini yazınız"></el-input>
          <el-button :loading="lo" type="success" size="small" class="btn-block text-center" :disabled="!Cevap"
                     @click="CevapGonder">Cevap Ver
          </el-button>
        </div>
      </el-col>
    </el-row>

  </div>
</template>
<script>
import Yukleniyor from "../../../components/Doc/Yukleniyor";
import BilgiKutu from "../../../components/Pack/Genel/BilgiKutu";

export default {
  components: {BilgiKutu, Yukleniyor},
  props: ['id'],

  data() {
    return {
      Turler: [
        {id: '2', Adi: 'Aktif'},
        {id: '1', Adi: 'Yeni'},
        {id: '3', Adi: 'Pasif'},
        {id: '4', Adi: 'Takvim'},
        {id: '5', Adi: 'Cevap Bekleniyor'},
      ],
      Cevap: '',
      DestekBilgi: null,
      lo: false
    }
  },
  methods: {
    SayfaYukle() {
      this.lo = true;
      this.$store.dispatch("Get", {path: 'spesiyal/destek/talep/' + this.id})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.Data = response.Data;
            this.Durum = this.Data.Durum;
            this.Yorumlar = response.Yorumlar;
            this.DestekBilgi = {
              Durum: this.Data.DurumText,
              Baslik: this.Data.Baslik,
              Tarih: this.Data.tarih,
              DurumText: this.Data.DurumText
            };
          }
        });
    },
    CevapGonder() {
      this.lo = true;
      this.dialogVisible = false;
      this.$store.dispatch("Post", {Cevap: this.Cevap, id: this.id, path: 'spesiyal/destek/destekcevap'})
        .then(response => {
          if (response.Durum == "OK") {
            this.$message.success(response.Mesaj);
            this.lo = false;
            this.Cevap = '';

            this.SayfaYukle();
          } else {
            this.$message.error(response.Mesaj);
            this.lo = false;
          }
        })
    }
  },
  created() {
    this.SayfaYukle();
  },
  computed: {
    SayfaYenile() {
      return this.id
    },
  },
  watch: {
    SayfaYenile() {
      var oid = this.id;
      this.id = null;
      this.id = oid;
      this.SayfaYukle();
    },
  }
}
</script>

<style scoped>
h5.Baslik {
  padding-right: 100px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.SayfaYukle {
  position: absolute;
  right: 16px;
  top: 0px;
  z-index: 9;
}

.Yorumlar {
  height: calc(100vh - 150px);
  overflow: scroll;
}

.Yorum {
  padding: 10px;
  border-radius: 3px;
  border: 2px solid #ccc;
  margin-bottom: 40px;
  position: relative;
  margin-right: 120px;
}

.Yorum.ai {
  border-color: #3c7ae1;
  margin-left: 120px;
  margin-right: 0;

}

.Yorum.ai .Kisi {
  right: 0;
  left: inherit;
  text-align: right;
}

.Yorum.ai .Tarih {
  left: 0;
}

.Yorum .Icerik {
  font-size: 12px;
}

.Yorum .Tarih {
  font-size: 12px;
  right: 0;
  position: absolute;
  display: inline-block;
  margin: 0;
  bottom: -20px;
}

.Yorum .Kisi {
  font-size: 12px;
  left: 0;
  position: absolute;
  display: inline-block;
  margin: 0;
  bottom: -35px;
  text-align: left;
}

.Yorum .Kisi small {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Doc/Destek/DestekDetay.vue